// Local dev only: env.js points the app at http://localhost:8800. Opened from
// another device on the home network (http://192.168.1.57:5291 on a phone),
// "localhost" is that device, so every call goes nowhere. When the configured
// URL is localhost and the page is not, use the page's own host instead.
// Production URLs are never localhost, so they pass through unchanged.
const LOCAL = ['localhost', '127.0.0.1']

export function onPageHost (url, pageHost = (typeof window !== 'undefined' ? window.location.hostname : '')) {
  if (!url || !pageHost || LOCAL.includes(pageHost)) return url
  try {
    const u = new URL(url)
    if (!LOCAL.includes(u.hostname)) return url
    u.hostname = pageHost
    return url.endsWith('/') ? u.toString() : u.toString().replace(/\/$/, '')
  } catch {
    return url
  }
}
